(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt_shop-product-details"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // // Function to observe shadow DOM and remove subscription text
    // function watchShadowElement(hostSelector, shadowSelector, callback) {
    //   let shadowObserver = null;
    //   const setupShadowObserver = (shadowRoot) => {
    //     // Remove element if it already exists
    //     const existing = shadowRoot.querySelector(shadowSelector);
    //     if (existing) {
    //       callback(existing);
    //     }
    //     console.log();
    //     // Watch for future additions
    //     shadowObserver = new MutationObserver(() => {
    //       const element = shadowRoot.querySelector(shadowSelector);
    //       if (element) {
    //         callback(element);
    //       }
    //     });
    //     shadowObserver.observe(shadowRoot, {
    //       childList: true,
    //       subtree: true,
    //     });
    //   };
    //   const checkForShadowRoot = () => {
    //     const host = document.querySelector(hostSelector);
    //     if (host?.shadowRoot) {
    //       setupShadowObserver(host.shadowRoot);
    //       return true;
    //     }
    //     return false;
    //   };
    //   // Try immediately
    //   if (!checkForShadowRoot()) {
    //     // Watch for the host element to appear with shadow root
    //     const hostObserver = new MutationObserver(() => {
    //       if (checkForShadowRoot()) {
    //         hostObserver.disconnect();
    //       }
    //     });
    //     hostObserver.observe(document.body, {
    //       childList: true,
    //       subtree: true,
    //     });
    //   }
    //   // Return cleanup function
    //   return () => {
    //     if (shadowObserver) {
    //       shadowObserver.disconnect();
    //     }
    //   };
    // }
    // // Usage: Remove subscription text
    // const stopWatching = watchShadowElement('#upCart', '.upcart-item-property-subscription', (element) => {
    //   element.remove();
    // });
    // // Usage: Hide VIP CLUB product from cart with detailed debugging
    // function hideVipClubProducts() {
    //   console.log('🚀 Starting VIP CLUB product check...');
    //   const upCart = document.querySelector('#upCart');
    //   if (!upCart || !upCart.shadowRoot) {
    //     return;
    //   }
    //   const shadowRoot = upCart.shadowRoot;
    //   // Find all product items
    //   const allProducts = shadowRoot.querySelectorAll('.upcart-product-item');
    //   allProducts.forEach((product, index) => {
    //     const vipClubLink = product.querySelector('a[href*="aureon-vip-club"]');
    //     const productTitle = product.querySelector('.upcart-product-title-link');
    //     const productId = product.id;
    //     if (vipClubLink || (productTitle && productTitle.textContent.trim().includes('AUREON VIP CLUB'))) {
    //       product.style.display = 'none';
    //       product.style.visibility = 'hidden';
    //       product.style.height = '0';
    //       product.style.overflow = 'hidden';
    //     } else {
    //     }
    //   });
    // }
    // // Run immediately and watch for changes
    // setTimeout(hideVipClubProducts, 500);
    // setTimeout(hideVipClubProducts, 1000);
    // setTimeout(hideVipClubProducts, 2000);
    // const stopWatchingVipClub = watchShadowElement('#upCart', '.upcart-product-item', (element) => {
    //   hideVipClubProducts();
    // });
  });

  } catch(e) { console.error(e); }
})();
})();
